import UserProfile from "views/Pages/UserProfile.jsx";
import Accounting from "views/Pages/Accounting.jsx"
import ProviderInfo from "views/Pages/ProviderInfo.jsx"
import Patients from "views/Pages/Patients.jsx"
import RegisterPatient from "views/Pages/RegisterPatient.jsx"
import OrganizationProvider from "views/Pages/OrganizationProvider.jsx"
import Invitations from "views/Pages/Invitations.jsx"
import Subscriptions from "views/Pages/Subscriptions.jsx"
import ClientMap from "views/Pages/CirrusAdmin/ClientMap.jsx"
import Tools from "views/Pages/Tools.jsx";
import Settings from "views/Pages/Settings.jsx";
import Assessment from "views/Pages/Assessment.jsx";
import Support from "views/Pages/Support.jsx";



import Dashboard from "views/Pages/Dashboard.jsx"

// @material-ui/icons
import PersonIcon from "@material-ui/icons/Person";
import PersonAdd from "@material-ui/icons/PersonAdd";
import Place from "@material-ui/icons/Place";
import AttachMoney from "@material-ui/icons/AttachMoney";
import LocalHospital from "@material-ui/icons/LocalHospital";
import Assignment from "@material-ui/icons/Assignment";
import AssignmentTurnedIn from "@material-ui/icons/AssignmentTurnedIn";
import People from "@material-ui/icons/People";
import Build from "@material-ui/icons/Build";
import SettingsIcon from "@material-ui/icons/Settings";
import AssessmentIcon from "@material-ui/icons/Assessment";

import DashboardIcon from "@material-ui/icons/Dashboard";

// Convert to a function so routes are always fresh based on current session
function getDashboardRoutes() {
  var dashRoutes = []
  var userGroups = []
  if (sessionStorage.getItem('userGroups')) {
    userGroups = JSON.parse(sessionStorage.getItem('userGroups'))
  }

  if (userGroups.indexOf('organization') >= 0 || userGroups.indexOf('cirrusAdmin') >= 0) {
    dashRoutes.push({
      path: "/dashboard",
      name: "Dashboard",
      icon: DashboardIcon,
      component: Dashboard
    })
  }


  if (userGroups.indexOf('organization') >= 0) {
    dashRoutes.push({
      path: "/registerPatient",
      name: "Register a Patient",
      icon: Assignment,
      component: RegisterPatient
    })
  }

  if (userGroups.indexOf('cirrusAdmin') < 0 && userGroups.indexOf('assessment') < 0) {
    dashRoutes.push({
      path: "/accounting",
      name: "Accounting",
      icon: AttachMoney,
      component: Accounting
    })
  }



  if (userGroups.indexOf('patient') >= 0) {
    dashRoutes.push({
      path: "/providerInfo",
      name: "Provider",
      icon: LocalHospital,
      component: ProviderInfo
    })
    dashRoutes.push({
      path: "/family",
      name: "Family",
      icon: People,
      component: Patients
    })
  }

  if (userGroups.indexOf('employer') >= 0) {
    dashRoutes.push({
      path: "/employees",
      name: "Employees",
      icon: People,
      component: Patients
    })
    dashRoutes.push({
      path: "/subscriptions",
      name: "Subscriptions",
      icon: AssignmentTurnedIn,
      component: Subscriptions
    })
  }

  if (userGroups.indexOf('organization') >= 0) {
    dashRoutes.push({
      path: "/pendingTransactions",
      name: "Pending Transactions",
      icon: AttachMoney,
      component: Accounting
    })
    dashRoutes.push({
      path: "/patients",
      name: "Patients",
      icon: PersonIcon,
      component: Patients
    })
    dashRoutes.push({
      path: "/organizationProvider",
      name: "Providers",
      icon: PersonIcon,
      component: OrganizationProvider
    })
    dashRoutes.push({
      path: "/invitations",
      name: "Invite Patients",
      icon: PersonAdd,
      component: Invitations
    })
  }

  if (userGroups.indexOf('cirrusAdmin') >= 0) {
    dashRoutes.push({
      path: "/clientMap",
      name: "Client Map",
      icon: Place,
      component: ClientMap
    })
  }

  if (userGroups.indexOf('assessment') >= 0) {
    dashRoutes.push({
      path: "/assessment",
      name: "Assessment",
      icon: AssessmentIcon,
      component: Assessment
    })
  }

  dashRoutes.push({
    path: "/userPage",
    name: "User Profile",
    icon: PersonIcon,
    component: UserProfile
  })

  if (userGroups.indexOf('organization') >= 0) {
    dashRoutes.push({
      path: "/tools",
      name: "Tools",
      icon: Build,
      component: Tools
    })
    dashRoutes.push({
      path: "/settings",
      name: "Settings",
      icon: SettingsIcon,
      component: Settings
    })
  }

  if (userGroups.indexOf('admin') >= 0) {
    dashRoutes.push({
      path: "/support",
      name: "Support",
      icon: SettingsIcon,
      component: Support
    })
  }

  if (userGroups.indexOf('organization') >= 0) {
    dashRoutes.push({ redirect: true, path: "/", pathTo: "/registerPatient", name: "Register a Patient" })
  } else if (userGroups.indexOf('assessment') >= 0) {
    dashRoutes.push({ redirect: true, path: "/", pathTo: "/assessment", name: "Assessment" })
  } else if (userGroups.indexOf('cirrusAdmin') >= 0) {
    dashRoutes.push({ redirect: true, path: "/", pathTo: "/dashboard", name: "Dashboard" })
  } else {
    dashRoutes.push({ redirect: true, path: "/", pathTo: "/accounting", name: "Accounting" })
  }

  return dashRoutes;
}

// Export the function
export default getDashboardRoutes;

// Also export a getter for current routes (for backward compatibility)
export function dashboardRoutes() {
  return getDashboardRoutes();
}
